module.exports = __webpack_public_path__ + "media/images/arrow_right-1a628fe8f5b1bcf619b9a1dabcd81fa3.png";